import List from "@/components/list";
import vue from "@/main";
import router from "@/router";
import Bus from "./bus";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const RCsortChange = args.listeners["sort-change"] || function() {};
  const changePort = listeners["change-port"] || function() {};

  // 编辑专题
  function editSubjectInfo(entity) {
    let uuid = entity.uuid;
    let flag = 0;
    if (entity.parentId != null && entity.parentId != "") {
      uuid = entity.parentId;
      flag = 1;
    }
    router.push({
      path: "/subjectInfo/add",
      query: { uuid: uuid, flag: flag, onlineStatus: entity.onlineStatus },
    });
  }

  // 删除专题
  function deleteSubjectInfo(question) {
    vue.$emit("deleteSubjectInfo", question);
  }

  function setDown(data, type) {
    vue.$emit("setDown", { id: data, status: type });
  }
  function setUp(data, type) {
    vue.$emit("setDown", { id: data, status: type });
  }
  function resourceConfig({ row }) {
    let uuid = row.uuid;
    let flag = 0;
    if (row.parentId != null && row.parentId != "") {
      uuid = row.parentId;
      flag = 1;
    }
    router.push({
      path: "/subjectInfo/subjectBlockConfig",
      query: { id: uuid, flag: flag },
    });
  }
  function shareManage(id) {
    Bus.$emit("shareManage", id);
  }
  const Deal = ({ props: { vo } }) => {
    const paper = vo.row;
    const dealConf = [
      [
        paper.enableShared === 1 ? "icon-edit" : "icon-edit-disable",
        "编辑",
        paper.enableShared === 1
          ? () => {
              editSubjectInfo(paper);
            }
          : "",
        "subjectInfo:update",
      ],
      [
        paper.onlineStatus === 0 ? "icon-delete" : "icon-delete-disable",
        "删除",
        paper.onlineStatus === 0
          ? () => {
              deleteSubjectInfo(paper);
            }
          : () => {},
        "subjectInfo:delete",
      ],
      [
        "icon-resource-config",
        "资源配置",
        () => resourceConfig(vo),
        "subjectBlockConfig:page",
      ],
    ];
    if (vo.row.enableShared) {
      dealConf.push([
        "icon-share",
        "共享管理",
        () => shareManage(vo.row.uuid),
        "subjectInfo:sharePage",
      ]);
    } else {
      dealConf.push([
        "icon-share-none",
        "共享管理",
        () => {},
        "subjectInfo:sharePage",
      ]);
    }
    if (vo.row.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => {
          setDown(vo.row.uuid, 0);
        },
        "subjectInfo:onlineStatus",
      ]);
    } else {
      dealConf.push([
        "icon-up",
        "上线",
        () => {
          setUp(vo.row.uuid, 1);
        },
        "subjectInfo:onlineStatus",
      ]);
    }

    // dealConf.push([
    //   paper.onlineStatus == 1
    //     ? "iconfont icxiugaizhanshizhongduan iconfont-adapt-disabled"
    //     : "iconfont icxiugaizhanshizhongduan iconfont-adapt",
    //   "修改展示终端",
    //   paper.onlineStatus == 1 ? () => {} : () => changePort(paper),
    //   "subject:updateDisplay",
    // ]);
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const SharedDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.sharedDeptName || "--"}</span>;
  };
  const FormDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.formDeptName || "--"}</span>;
  };

  const SubjectName = ({ props: { vo } }) => {
    return (
      <div
        class="base-hover-char"
        onClick={() => {
          router.push({
            path: "/subjectInfo/detail",
            query: { id: vo.row.uuid },
          });
        }}
      >
        {vo.row.subjectName}
      </div>
    );
  };

  const OnlineDate = ({ props: { vo } }) => {
    return <span>{vo.row.onlineDate || "--"}</span>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "专题名称",
      minWidth: "200",
      render: (vo) => <SubjectName vo={vo} />,
    },
    {
      label: "已共享学院",
      prop: "sharedDeptName",
      minWidth: "150",
      render: (vo) => <SharedDeptName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      width: "70",
    },
    {
      label: "版权方",
      prop: "formDeptName",
      width: "140",
      render: (vo) => <FormDeptName vo={vo} />,
      showOverflowTooltip: true,
    },
    // {
    //   label: "排序",
    //   prop: "order",
    //   sortable: "custom",
    //   width: "70",
    // },
    {
      label: "展示终端",
      prop: "clientNames",
      width: "150",
    },
    {
      label: "上线时间",
      prop: "onlineDate",
      width: "150",
      render: (vo) => <OnlineDate vo={vo} />,
    },
    {
      label: "操作",
      fixed: "right",
      width: "160",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      onSortChange={RCsortChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
